<template>
  <div class="container">
    <div class="leadButton">
      <img src="../assets/ChatBotIconRobo.png" width="70" height="70">
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      showBorder: false
    }
  }
}
</script>

<style>
.leadButton {
  backface-visibility: hidden;
  display: flex;
  position: absolute;
  bottom: 15px;
  right: 15px;
  -webkit-transition:  0.3s linear;
  transition: all 0.3s linear;
  cursor: pointer;
  max-width: 100%;
  height: auto;
  -webkit-filter: drop-shadow(0px 0px 2px #afabab);
  filter: drop-shadow(0px 0px 2px #afabab);
}

.leadButton:hover {
  -webkit-filter: drop-shadow(0px 0px 4px #707070);
  filter: drop-shadow(0px 0px 4px #707070);
}

.leadButton:hover::after {
  opacity: 1;
}

.showBorder {
  -webkit-filter: drop-shadow(0px 0px 5px #707070);
  filter: drop-shadow(0px 0px 5px #707070);
}

</style>



// WEBPACK FOOTER //
// src/components/ChatButton.vue